export default "__VITE_ASSET__4fe255ac__"